import { render, staticRenderFns } from "./showWhap.vue?vue&type=template&id=b99ddc0e&scoped=true"
import script from "./showWhap.vue?vue&type=script&lang=js"
export * from "./showWhap.vue?vue&type=script&lang=js"
import style0 from "./showWhap.vue?vue&type=style&index=0&id=b99ddc0e&prod&scoped=true&lang=css"
import style1 from "./showWhap.vue?vue&type=style&index=1&id=b99ddc0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99ddc0e",
  null
  
)

export default component.exports